// extracted by mini-css-extract-plugin
export default {"ERROR":"page_ERROR__rTZkV","box":"page_box__h5i8R","btn_area":"page_btn_area__IHR1v"};